export const setUrlRequest = payload => {
    return {
        type: "SET_URL_REQUEST",
        payload: payload
    }
}